import React, { useEffect, useState } from "react";
import jaqkCoin from "../../assets/images/jaqk-coin.svg";

const CircularProgressBar = ({ value, maxValue }) => {
  // const speed = maxValue > 800 ? 0 : 50;
  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    if (maxValue > 100) {
      setProgressValue(value);
    } else {
      const interval = setInterval(() => {
        setProgressValue((prevValue) => {
          const newValue = Math.min(prevValue + 1, value);
          if (newValue === value) {
            clearInterval(interval);
          }
          return newValue;
        });
      }, 50);

      return () => {
        clearInterval(interval);
      };
    }
  }, [value, maxValue]);

  return (
    <div className="progress-bar-container">
      <svg
        className="circular-progress"
        width="120"
        height="120"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle className="background-circle" r="50" cx="60" cy="60" />
        <circle
          className={`${maxValue == 0 ? "no-progress" : " progress-circle"}`}
          r="50"
          cx="60"
          cy="60"
          style={{
            strokeDasharray: 314,
            strokeDashoffset: 314 - (314 * progressValue) / maxValue,
          }}
        />
      </svg>
      <div className="progress-value SB-inner-circleCount">
        {Math.floor(progressValue).toLocaleString()}
      </div>
    </div>
  );
};

export default CircularProgressBar;
